<template xmlns:v-bind="http://www.w3.org/1999/xhtml">
  <div class="container-fluid" id="blurry">
    <div class="row signup-page">
      <div class="circle_background_mob" ></div>
      <div class="col-lg-12 touch_bottom">
        <div class="signup-page--right whiteandround">
          <div class="login-form">
            <!--<div class="logo_form"><img :src="getTranslations.logo_for_branded_projects || 'static/images/Swipo_logo_02.png'" alt=""></div>-->
            <div class="form_title">
            <span>{{ getTranslations.visitor_forgot_password_2_2_steps_left }}</span>
          </div>
          </div>
          <div class="col-lg-12">
            <div class="StandardRegSteps_Container">
              <div class="StandardRegSteps_step step_done">1</div>
              <div class="StandardRegSteps_step">2</div>
              <div class="StandardRegSteps_step inactive">3</div>
            </div>
          </div>
          <div class="signup-form">
            <div class="form-help extra_padng">
              <img class="form-help__icon "
                   src="static/images/icon-mobile-pin.svg" alt="">
              <p>{{ getTranslations.visitor_forgot_password_2_send_unique_code_msg }}</p>
            </div>
            <form action="">
              <div :class="['form-group form-group--mobile form-group--icon', !hasErrors ? '' : 'has-warning' ]">
                <input type="number"
                       pattern="[0-9]*" inputmode="numeric"
                       class="password form-group__textfield phone_input"
                       :placeholder="getTranslations.visitor_forgot_password_2_enter_4digit_validation_code"
                       @keyup="check"
                       v-model="pin" />
                <span class="form-group__feedback"
                      v-show="getMessage(message) && pin">
                       {{ getMessage(message) }}
                </span>
              </div>
              <div class="col-lg-12">
                <img class="info_icon"
                     src="static/images/icon-info-XL.svg"/>
                <p>{{ getTranslations.visitor_forgot_password_2_keep_your_pin }}</p>
              </div>
              <button type="submit"
                      :class="['btn btn--medium btn--main',( hasErrors ? 'deactivated' : '')]"
                      @click.prevent="checkButton">
                {{ getTranslations.visitor_forgot_password_2_button_continue }}
              </button>
              <!--ADD CLASS "deactivated" IF "has-warning" IS ACTIVE AS WELL ABOVE-->
              <!--span class="form-group__code">$#You need a new unique code? <a href="#">$#Resend me a code</a></span-->
            </form>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations, mapState } from 'vuex';

export default {
  data() {
    return {
      pin: '',
      message: '',
      hasErrors: false,
    };
  },
  methods: {
    ...mapMutations('profile', [
      'setHashedPassForForgotPass',
    ]),
    getMessage(key) {
      if (key === 'SERVER_ERROR') return key;
      return this.getTranslationByOperator(this.multiOperatorInfo.multiOperatorOrdinal, key) || '';
    },
    clearData() {
      this.pin = '';
      this.message = '';
      this.hasErrors = false;
    },
    check() {
      const validPinRegex = /^[0-9]{0,8}$/;
      const validPin = this.pin.match(validPinRegex);
      if (!validPin) {
        this.message = 'visitor_forgot_password_2_warning_msg_wrong_verification_code';
        this.hasErrors = true;
      } else {
        this.hasErrors = false;
        this.message = '';
      }
    },
    checkButton() {
      if (this.pin.length >= 4 && this.pin.length <= 8 && !this.hasErrors) {
        this.message = '';
        this.$axios.get(`api/verifyPinForForgotPassword?msisdn=${this.forgotPasswordInfo}&pin=${this.pin}`).then((response) => {
          const resp = response.data.responseEnum;
          if (resp === 'OPERATION_SUCCESS') {
            this.setHashedPassForForgotPass(response.data.data.hashedPass);
            this.$router.push('forgotPassword3');
            this.message = '';
          } else {
            if (resp === 'PIN_EXPIRED') {
              this.message = 'visitor_sign_up_2_pin_expired';
            } else if (resp === 'WRONG_PIN') {
              this.message = 'visitor_forgot_password_2_warning_msg_wrong_verification_code';
            } else if (resp === 'BLOCKED_USER') {
              this.message = 'visitor_forgot_password_warning_msd_max_attempts';
            } else if (resp === 'SERVER_ERROR') {
              this.message = 'SERVER_ERROR';
            } else if ((resp === 'THIRD_PARTY_PIN_REQUEST_FAILED') || (resp === 'THIRD_PARTY_PIN_VERIFICATION_FAILED') || (resp === 'THIRD_PARTY_SUBSCRIPTION_PIN_REQUEST_FAILED')) {
              this.message = 'visitor_sign_up_warning_third_party_error';
            }
            this.hasErrors = true;
          }
        });
      } else {
        this.message = 'visitor_forgot_password_2_warning_msg_wrong_verification_code';
        this.hasErrors = true;
      }
    },
  },
  computed: {
    ...mapState('common', [
      'multiOperatorInfo',
    ]),
    ...mapState('profile', [
      'forgotPasswordInfo',
    ]),
    ...mapGetters('i18n', [
      'getTranslations',
      'getTranslationByOperator',
    ]),
  },
};
</script>



// WEBPACK FOOTER //
// src/components/visitor/forgotPassword/ForgotPassword2.vue